/**
 * The possible identification keys of a report as a list, whatever form they are in: a list, the text the API
 * stores (a JSON array such as `["A","B"]`), a JSON string holding comma separated keys (`"A,B"`, which an earlier
 * version of the item form saved after an item was removed), or a bare key or comma separated keys.
 * Blank keys are left out.
 */
export function possibleIdentificationKeys(value: string[] | string | null | undefined): string[] {
  if (Array.isArray(value)) {
    return value.map((key) => String(key ?? '').trim()).filter((key) => key !== '');
  }

  return keysFromText(value, true);
}

function keysFromText(value: string | null | undefined, mayBeEncodedAgain: boolean): string[] {
  const text = (value ?? '').trim();

  if (text.startsWith('[')) {
    try {
      const parsed = JSON.parse(text);
      if (Array.isArray(parsed)) {
        return possibleIdentificationKeys(parsed);
      }
    } catch {
      // not valid JSON after all; the text is one key
    }
    return [text];
  }

  if (text.startsWith('"') && mayBeEncodedAgain) {
    try {
      const parsed = JSON.parse(text);
      if (typeof parsed === 'string') {
        return keysFromText(parsed, false);
      }
    } catch {
      // not valid JSON after all; the quotes are part of the text
    }
  }

  return text
    .split(',')
    .map((key) => key.trim())
    .filter((key) => key !== '');
}
